import React, { useEffect, useState } from 'react';
import { CheckCircleIcon, XIcon } from 'lucide-react';
const names = ['Valentina', 'Matías', 'Lucía', 'Sebastián', 'Camila', 'Diego', 'Florencia', 'Ramiro', 'Agustina', 'Nicolás', 'Martina', 'Joaquín', 'Sofía', 'Tomás', 'Julieta', 'Bruno', 'Antonella', 'Federico', 'Micaela', 'Gonzalo'];
const locations = ['Buenos Aires, CABA', 'La Plata, Buenos Aires', 'Mar del Plata, Buenos Aires', 'Bahía Blanca, Buenos Aires', 'Córdoba Capital, Córdoba', 'Río Cuarto, Córdoba', 'Villa María, Córdoba', 'Rosario, Santa Fe', 'Santa Fe Capital, Santa Fe', 'Mendoza Capital, Mendoza', 'San Rafael, Mendoza', 'San Miguel de Tucumán, Tucumán', 'Salta Capital, Salta', 'San Salvador de Jujuy, Jujuy', 'Neuquén Capital, Neuquén', 'San Carlos de Bariloche, Río Negro', 'General Roca, Río Negro', 'Posadas, Misiones', 'Resistencia, Chaco', 'Corrientes Capital, Corrientes', 'Paraná, Entre Ríos', 'Concordia, Entre Ríos', 'Santiago del Estero, Santiago del Estero', 'La Rioja Capital, La Rioja', 'San Juan Capital, San Juan', 'San Luis Capital, San Luis', 'Catamarca, Catamarca', 'Formosa Capital, Formosa', 'Comodoro Rivadavia, Chubut', 'Río Gallegos, Santa Cruz', 'Ushuaia, Tierra del Fuego', 'Viedma, Río Negro', 'Rawson, Chubut', 'San Fernando del Valle, Catamarca'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentLocation, setCurrentLocation] = useState('');
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomLocation = locations[Math.floor(Math.random() * locations.length)];
      setCurrentName(randomName);
      setCurrentLocation(randomLocation);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Initial delay (10-20s)
    const initialDelay = Math.random() * 10000 + 10000;
    const initialTimer = setTimeout(showPopup, initialDelay);
    // Recurring interval (every 20-35s)
    const interval = setInterval(() => {
      const delay = Math.random() * 15000 + 5000;
      setTimeout(showPopup, delay);
    }, 30000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-3 left-3 z-50 animate-slide-in" data-id="element-509" data-mp="2plbyk79javlh">
      <div className="relative bg-slate-900/90 backdrop-blur-xl rounded-xl shadow-[0_0_30px_rgba(34,197,94,0.35)] py-3 pl-4 pr-8 max-w-[290px] border border-green-500/40 overflow-hidden" data-id="element-510" data-mp="1ryv2f5cjeo1b">
        <div className="absolute top-0 left-0 h-full w-1 bg-gradient-to-b from-green-400 to-green-600 shadow-[0_0_12px_rgba(34,197,94,0.8)]" data-id="element-511" data-mp="21vpwnc1s229s" />
        <button onClick={() => setIsVisible(false)} className="absolute top-1.5 right-1.5 text-slate-500 hover:text-slate-200 transition-colors" aria-label="Cerrar notificación" data-id="element-512" data-mp="26oj62d86xys7">
          <XIcon className="h-3.5 w-3.5" data-id="element-513" data-mp="1e5nblfwa5wko" />
        </button>
        <div className="flex items-start gap-2.5" data-id="element-514" data-mp="3rgyifs5uuuju">
          <div className="bg-green-500/15 rounded-full p-1 flex-shrink-0 mt-0.5 shadow-[0_0_12px_rgba(34,197,94,0.4)]" data-id="element-515" data-mp="3rgexe2kwrq1l">
            <CheckCircleIcon className="h-4 w-4 text-green-400" data-id="element-516" data-mp="3nd8rwx5me2w6" />
          </div>
          <div className="min-w-0" data-id="element-517" data-mp="3iep6qyyuov4v">
            <p className="text-xs font-bold text-white truncate" data-id="element-518" data-mp="3dh5rbvqf2cbc">
              {currentName} de {currentLocation}
            </p>
            <p className="text-[11px] text-slate-300 mt-0.5 leading-tight" data-id="element-519" data-mp="38icbhwnnq980">
              Acaba de comprar el{' '}
              <span className="text-green-400 font-bold" data-id="element-520" data-mp="33qklbn8ey5ie">
                Megapack Jurídico 2026
              </span>{' '}
              ✅
            </p>
            <p className="text-[9px] text-slate-500 mt-1 flex items-center gap-1" data-id="element-521" data-mp="2uqnzruhblmrk">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" data-id="element-522" data-mp="2uout4f6pj2jk" />
              Hace un momento
            </p>
          </div>
        </div>
      </div>
    </div>;
}